import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSessionTimeout = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1012,
			y1: 48.5488,
			x2: 17.1012,
			y2: 63.5488,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 95.3514,
			y1: 51.8292,
			x2: 111.351,
			y2: 71.8292,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 122.816,
			y1: 74.6997,
			x2: 178.816,
			y2: 49.5894,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 73.1104C13.4183 73.1104 17 69.5286 17 65.1104C17 60.6921 13.4183 57.1104 8.99999 57.1104C4.58171 57.1104 1 60.6921 1 65.1104C1 69.5286 4.58171 73.1104 8.99999 73.1104Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 68.1104C10.6568 68.1104 12 66.7672 12 65.1104C12 63.4535 10.6568 62.1104 8.99999 62.1104C7.34313 62.1104 6 63.4535 6 65.1104C6 66.7672 7.34313 68.1104 8.99999 68.1104Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 86.1104C120.418 86.1104 124 82.5286 124 78.1103C124 73.6921 120.418 70.1104 116 70.1104C111.582 70.1104 108 73.6921 108 78.1103C108 82.5286 111.582 86.1104 116 86.1104Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 81.1104C117.657 81.1104 119 79.7672 119 78.1104C119 76.4535 117.657 75.1104 116 75.1104C114.343 75.1104 113 76.4535 113 78.1104C113 79.7672 114.343 81.1104 116 81.1104Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 54.1113C94.4183 54.1113 98 50.5296 98 46.1113C98 41.6931 94.4183 38.1113 90 38.1113C85.5817 38.1113 82 41.6931 82 46.1113C82 50.5296 85.5817 54.1113 90 54.1113Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 49.1113C91.6569 49.1113 93 47.7682 93 46.1113C93 44.4545 91.6569 43.1113 90 43.1113C88.3431 43.1113 87 44.4545 87 46.1113C87 47.7682 88.3431 49.1113 90 49.1113Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 284.605,
			y1: 61.5254,
			x2: 225.174,
			y2: 86.4151,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 339.943,
			y1: 126.664,
			x2: 394.943,
			y2: 119.664,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 297.394,
			y1: 63.8924,
			x2: 328.394,
			y2: 119.892,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 135.11C336.418 135.11 340 131.529 340 127.11C340 122.692 336.418 119.11 332 119.11C327.582 119.11 324 122.692 324 127.11C324 131.529 327.582 135.11 332 135.11Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 130.11C333.657 130.11 335 128.767 335 127.11C335 125.454 333.657 124.11 332 124.11C330.343 124.11 329 125.454 329 127.11C329 128.767 330.343 130.11 332 130.11Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 127.11C407.418 127.11 411 123.529 411 119.11C411 114.692 407.418 111.11 403 111.11C398.582 111.11 395 114.692 395 119.11C395 123.529 398.582 127.11 403 127.11Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 122.11C404.657 122.11 406 120.767 406 119.11C406 117.453 404.657 116.11 403 116.11C401.343 116.11 400 117.453 400 119.11C400 120.767 401.343 122.11 403 122.11Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 66.1104C296.418 66.1104 300 62.5286 300 58.1104C300 53.6921 296.418 50.1104 292 50.1104C287.582 50.1104 284 53.6921 284 58.1104C284 62.5286 287.582 66.1104 292 66.1104Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 61.1104C293.657 61.1104 295 59.7672 295 58.1104C295 56.4535 293.657 55.1104 292 55.1104C290.343 55.1104 289 56.4535 289 58.1104C289 59.7672 290.343 61.1104 292 61.1104Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .7,
			d: "M199.732 75.0352L184.204 87.5001C175.912 94.155 171.158 103.768 171.158 113.873V132.729H241.264V113.873C241.264 103.768 236.51 94.1462 228.218 87.5001L212.69 75.0352C211.634 74.1902 211.035 72.9666 211.035 71.6814C211.035 70.3961 211.642 69.1726 212.69 68.3275L228.218 55.8627C236.51 49.2078 241.264 39.5951 241.264 29.4894V0.0175781H171.158V29.4894C171.158 39.5951 175.912 49.2166 184.204 55.8627L199.732 68.3275C200.789 69.1726 201.387 70.3961 201.387 71.6814C201.387 72.9666 200.78 74.1902 199.732 75.0352Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241.264 29.4797V0.0078125H226.414C230.023 30.2807 229.196 55.4304 215.129 66.3723L228.219 55.8618C236.511 49.2068 241.264 39.5941 241.264 29.4885V29.4797Z",
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241.263 132.729V113.873C241.263 103.767 236.509 94.146 228.217 87.4999L217.451 78.8555C217.451 78.8555 233.604 106.954 221.685 132.729H241.263Z",
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.291 25.2568C223.906 26.1019 213.184 29.1389 204.363 32.8537C213.157 35.9435 221.916 40.8731 229.231 47.9945C233.765 42.7481 236.291 36.2428 236.291 29.4822V25.2568Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M233.666 129.359C231.756 125.266 228.86 121.551 225.11 118.54L209.581 106.076C208.587 105.283 207.786 104.315 207.196 103.25C206.773 102.475 205.655 102.475 205.224 103.25C204.634 104.315 203.833 105.275 202.838 106.076L187.31 118.54C183.56 121.551 180.664 125.266 178.754 129.359H233.666Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M206.209 83.374C206.89 83.374 207.441 82.8222 207.441 82.1415C207.441 81.4609 206.89 80.9092 206.209 80.9092C205.528 80.9092 204.977 81.4609 204.977 82.1415C204.977 82.8222 205.528 83.374 206.209 83.374Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M206.209 92.581C206.89 92.581 207.441 92.0293 207.441 91.3486C207.441 90.668 206.89 90.1162 206.209 90.1162C205.528 90.1162 204.977 90.668 204.977 91.3486C204.977 92.0293 205.528 92.581 206.209 92.581Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M176.131 28.9105V29.4826C176.131 38.0742 180.207 46.2785 187.319 51.9827L202.847 64.4475C204.036 65.407 204.96 66.5954 205.559 67.9334C205.805 68.488 206.624 68.488 206.87 67.9334C207.469 66.6042 208.393 65.407 209.582 64.4475L225.11 51.9827C226.633 50.7591 228.006 49.4211 229.238 47.995C213.543 32.7133 191.219 27.5284 176.131 28.9105Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.96 0H240.463C243.755 0 246.431 2.67608 246.431 5.96834C246.431 8.97891 243.984 11.4261 240.974 11.4261H171.458C168.447 11.4261 166 8.97891 166 5.96834C166 2.67608 168.676 0 171.968 0H171.96Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.96 128.574H240.463C243.755 128.574 246.431 131.25 246.431 134.543C246.431 137.553 243.984 140 240.974 140H171.458C168.447 140 166 137.553 166 134.543C166 131.25 168.676 128.574 171.968 128.574H171.96Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M192.86 97.6265C196.483 95.1559 198.243 91.4274 196.792 89.2986C195.34 87.1697 191.226 87.4467 187.603 89.9173C183.98 92.3878 182.22 96.1164 183.671 98.2452C185.123 100.374 189.237 100.097 192.86 97.6265Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.338 104.218C182.475 103.443 182.908 102.099 182.305 101.215C181.703 100.331 180.293 100.243 179.156 101.018C178.019 101.793 177.586 103.138 178.189 104.022C178.791 104.906 180.201 104.994 181.338 104.218Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.6 33.4951C183.729 33.4951 185.455 30.559 185.455 26.937C185.455 23.3151 183.729 20.3789 181.6 20.3789C179.47 20.3789 177.744 23.3151 177.744 26.937C177.744 30.559 179.47 33.4951 181.6 33.4951Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 203.651,
			y1: 125.603,
			x2: 243.677,
			y2: 125.603,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.734 27.9134H173.284V27.9242L173.285 27.935L173.734 27.9134ZM181.593 50.2395C181.764 50.4199 182.049 50.4275 182.229 50.2566C182.41 50.0856 182.417 49.8008 182.246 49.6204L181.593 50.2395ZM173.284 14.3242V27.9134H174.184V14.3242H173.284ZM173.285 27.935C173.489 32.1699 173.582 35.6765 174.619 39.1507C175.663 42.6439 177.651 46.0799 181.593 50.2395L182.246 49.6204C178.375 45.5363 176.475 42.2195 175.482 38.8931C174.482 35.5476 174.389 32.1678 174.184 27.8918L173.285 27.935Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.074 0.365614C104.736 3.27007 105.28 6.19932 105.783 9.1296L106.502 13.5223L107.146 17.9289L104.986 16.7288L109.562 14.5446C111.087 13.8198 112.633 13.1406 114.165 12.4278L116.017 11.5711L116.338 13.5694C116.571 15.0047 116.76 16.4508 116.971 17.8915C117.181 19.3322 117.349 20.7837 117.54 22.22C117.698 23.6693 117.877 25.1132 118.003 26.5657C118.151 28.0128 118.265 29.4729 118.348 30.9362L117.133 31.1461C116.731 29.7345 116.359 28.3294 116.01 26.9092C115.65 25.4965 115.345 24.0654 115.016 22.6496C114.72 21.2207 114.401 19.807 114.117 18.3705C113.844 16.9363 113.546 15.5172 113.292 14.0873L115.465 15.2289C113.94 15.9537 112.423 16.6904 110.883 17.3914L106.273 19.4962L104.311 20.3897L104.103 18.2939L103.669 13.8625L103.298 9.42473C103.079 6.46552 102.902 3.49552 102.842 0.510479L104.064 0.36343L104.074 0.365614Z",
			fill: "#FF7B74"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.599 94C289.319 96.69 288.15 99.43 287.02 102.18L285.359 106.31L283.77 110.47L286.14 109.77L282.15 106.64C280.82 105.6 279.46 104.6 278.12 103.57L276.5 102.33L275.75 104.21C275.21 105.56 274.709 106.93 274.189 108.29C273.669 109.65 273.189 111.03 272.689 112.39C272.219 113.77 271.729 115.14 271.289 116.53C270.829 117.91 270.4 119.31 270 120.72L271.14 121.19C271.84 119.9 272.509 118.61 273.159 117.3C273.819 116 274.429 114.67 275.059 113.36C275.659 112.03 276.28 110.72 276.87 109.38C277.45 108.04 278.049 106.72 278.609 105.38L276.24 106.02C277.57 107.06 278.89 108.11 280.24 109.13L284.28 112.19L286 113.49L286.659 111.49L288.049 107.26L289.38 103.01C290.24 100.17 291.06 97.31 291.77 94.41L290.609 94H290.599Z",
			fill: "#FF7B74"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M55.2999 109.65C55.2999 111.67 53.6699 113.3 51.6499 113.3C49.6299 113.3 48 111.67 48 109.65C48 107.63 49.6299 106 51.6499 106C53.6699 106 55.2999 107.63 55.2999 109.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M379.3 64.65C379.3 66.67 377.67 68.3 375.65 68.3C373.63 68.3 372 66.67 372 64.65C372 62.63 373.63 61 375.65 61C377.67 61 379.3 62.63 379.3 64.65Z",
			fill: "#006ADC"
		})
	]
});
const ForwardRef = forwardRef(SvgSessionTimeout);
export default ForwardRef;
